module.exports = __webpack_public_path__ + "assets/img/93d4b067f603df5caf9c8bc4ec00aa05.svg";